import { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import './style.css'
import { useAuthContext } from '../../../hooks'
import Navbar from '../../../Components/Navbar'
import { getOrgUserDetails } from '../../../api/users/getOrgUserDetails'
import { useForm } from 'react-hook-form'

import { getOrgUserLeaveHistory } from '../../../api/LeaveManagement/getOrgUserLeaveHistory'
import { useNavigate, useParams } from 'react-router-dom'
import LeaveApprovalSc from './index.sc'
import { getOrgUserPtoMasterData } from '../../../api/LeaveManagement/getUserMasterPto'
import EmployeeLeaveChart from '../../../Components/Chart/todochart'
import { getEmployeeCurrentMonthLeave } from '../../../api/AdminLeaveManagement/getEmployeeCurrentmonthLeave'
function Leave() {
  const params = useParams()

  const auth = useAuthContext()

  const [leaveHistory, setLeaveHistory] = useState<any>([])
  const fetchOrgUserLeaveHistory = async () => {
    setLeaveHistory(
      await getOrgUserLeaveHistory(
        auth?.userInfo?.orgs[0]?.id,
        params?.employeeUserId,
      ),
    )
    console.log('leave history details')
  }
  const [masterData, setMasterData] = useState<any>([])
  const fetchAllUsersMasterPTO = async () => {
    await getOrgUserPtoMasterData(
      auth?.userInfo?.orgs[0]?.id,
      params?.employeeUserId,
    )
      .then((e) => {
        console.log(e)
        setMasterData(e)
      })
      .catch((e) => console.log(e))
  }
  const [month, setMonth] = useState<any>(null)
  const [year, setYear] = useState<any>(null)
  const [allLeaveMonth, setAllLeaveMonth] = useState<any>([])
  const fetchAllLeaveForTheCurrentMonth = async (month: any, year: any) => {
    await getEmployeeCurrentMonthLeave(
      auth?.userInfo?.orgs[0]?.id,
      params?.employeeUserId,
      month,
      year,
    )
      .then((e) => {
        console.log(e)
        setAllLeaveMonth(e)
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    fetchOrgUserLeaveHistory()
    fetchAllUsersMasterPTO()
  }, [])

  const triggerLeave = () => {
    fetchAllLeaveForTheCurrentMonth(month, year)
  }
  const d = new Date()
  const monthName = d.toLocaleString('en-US', { month: 'long' })

  return (
    <LeaveApprovalSc>
      <div className="name-card">
        {leaveHistory?.map((data: any) => {
          return (
            <>
              <div>{data?.first_name + ' ' + data?.last_name}</div>
            </>
          )
        })}
        <div>
          <EmployeeLeaveChart masterData={masterData} />
        </div>
      </div>
      <div className="leave-approval-card">
        <div className="leave-details-container-user">
          {leaveHistory?.map((data: any) => {
            return (
              <>
                <div className="total-leave-conatiner">
                  <p> Total Off</p>
                  <p>{data?.total_off}</p>
                </div>
                <div className="consumed-leave-container">
                  <p>Consumed Off</p>

                  <div>{data?.consumed_off}</div>
                </div>
                <div className="available-leave-container">
                  <p>Balance Off</p>
                  <div>{data?.available_off}</div>
                </div>
              </>
            )
          })}
        </div>
      </div>

      <table>
        <tr>
          <th className="heading">Applied Date</th>
          <th className="heading">From Date</th>
          <th className="heading">To Date</th>
          <th className="heading">Type OF Leave</th>
          <th className="heading">Reason</th>
          <th className="heading">Duration</th>
        </tr>
        {leaveHistory?.map((data: any) => {
          return (
            <>
              {data?.history?.map((data: any) => {
                return (
                  <>
                    <tr>
                      <td>{data?.applied_on}</td>
                      <td>{data?.start_date}</td>
                      <td>{data?.end}</td>
                      <td>{data?.leave_type_name}</td>
                      <td>{data?.reason}</td>
                      <td>{data?.duration}</td>
                    </tr>
                  </>
                )
              })}
            </>
          )
        })}
      </table>

      <h3>Month wise Report</h3>
      <div>
        <select onChange={(e) => setMonth(e.target.value)}>
          <option value={1}>Jan month</option>
          <option value={2}>feb month</option>
          <option value={3}>March month</option>
          <option value={4}>April month</option>
          <option value={5}>may month</option>
          <option value={6}>June month</option>
          <option value={7}>July month</option>
          <option value={8}>August month</option>
          <option value={9}>September month</option>
          <option value={10}>October month</option>
          <option value={11}>November month</option>
          <option value={12}>Decemeber month</option>
        </select>
        <select onChange={(e) => setYear(e.target.value)}>
          <option value={2022}>2022</option>
          <option value={2023}>2023</option>
          <option value={2024}>2024</option>
          <option value={2025}>2025</option>
        </select>
      </div>
      <button onClick={triggerLeave}>Get report</button>
      {allLeaveMonth?.map((data: any) => {
        return (
          <>
            <div>
              First half pto: {''}
              {data?.first_half_leave_pto} days
            </div>
            <div>
              Second half pto: {''}
              {data?.second_half_leave_pto} days
            </div>
            <div>
              First half emergency pto: {''}
              {data?.first_half_e_pto} days
            </div>
            <div>
              Second half emergency pto: {''}
              {data?.second_half_e_pto} days
            </div>
            <div>
              First half work from home : {''}
              {data?.first_w_f_h} days
            </div>
            <div>
              Second half work from home : {''}
              {data?.second_w_f_h} days
            </div>
            <div>
              First half Loss of pay : {''}
              {data?.first_w_f_h} days
            </div>
            <div>
              Second half Loss of pay : {''}
              {data?.second_lop} days
            </div>
          </>
        )
      })}
    </LeaveApprovalSc>
  )
}

export default Leave
